import React, { useEffect, useState } from "react";

import { CloseIcon } from "@/components/Icons/CloseIcon";
import { ICON_SIZES, ICON_TYPES } from "@/constants/icons";
import { Modal } from "@/component-library/Modal";

import { filterActiveGoals } from "../helpers";
import { MODAL_MODES } from "../constants";

import {
  AddGoalForm,
  AddObjectiveForm,
  CompleteObjectiveForm,
  EditObjectiveForm,
  RemoveObjectiveForm,
} from "./CareGoalsForms";

export function CareGoalModal(props) {
  const [allowOverflow, setAllowOverflow] = useState(false);
  const filteredProviderGoalOptions = filterActiveGoals(
    props.providerTypeCurrentGoalsAndObjectives || [],
    props.providerGoalOptions || [],
  );

  useEffect(() => {
    setAllowOverflow(props.modalMode === MODAL_MODES.ADD_GOAL);
  }, [props.modalMode]);

  const isNestedFlow = [MODAL_MODES.CLOSE_AND_ADD_OBJECTIVE].includes(props.modalMode);
  const cardClassName = `CareGoalsCard--modal_dialog${allowOverflow ? "--allow-overflow" : ""}`;

  return (
    <Modal cardClassName={cardClassName} className="CareGoalsCard--modal" show={props.show}>
      {!isNestedFlow && (
        <CloseIcon
          className="CareGoalsCard--modal_close_icon"
          iconSize={ICON_SIZES.SMALL}
          iconType={ICON_TYPES.OUTLINE}
          onClick={props.onClose}
        />
      )}

      {props.modalMode === MODAL_MODES.ADD_GOAL && (
        <AddGoalForm
          onClose={props.onClose}
          onModalSubmission={props.onModalSubmission}
          patientDetails={props.patientDetails}
          providerGoalOptions={filteredProviderGoalOptions}
          providerGoalOptionsMap={props.providerGoalOptionsMap}
          providerLabel={props.providerLabel}
          providerObjectiveOptions={props.providerObjectiveOptions}
          providerObjectiveOptionsMap={props.providerObjectiveOptionsMap}
          setAllowOverflow={setAllowOverflow}
        />
      )}
      {props.modalMode === MODAL_MODES.ADD_OBJECTIVE && (
        <AddObjectiveForm
          goal={props.goal}
          objective={null}
          objectiveCloseMode={null}
          onClose={props.onClose}
          onModalSubmission={props.onModalSubmission}
          patientDetails={props.patientDetails}
          providerObjectiveOptions={props.providerObjectiveOptions}
          providerObjectiveOptionsMap={props.providerObjectiveOptionsMap}
        />
      )}
      {props.modalMode === MODAL_MODES.EDIT_OBJECTIVE && (
        <EditObjectiveForm
          goal={props.goal}
          objective={props.objective}
          onClose={props.onClose}
          onModalSubmission={props.onModalSubmission}
          patientDetails={props.patientDetails}
        />
      )}
      {props.modalMode === MODAL_MODES.COMPLETE_OBJECTIVE && (
        <CompleteObjectiveForm
          goal={props.goal}
          objective={props.objective}
          onClose={props.onClose}
          onCloseAndAddObjective={props.onCloseAndAddObjective}
          onModalSubmission={props.onModalSubmission}
          patientDetails={props.patientDetails}
        />
      )}
      {props.modalMode === MODAL_MODES.REMOVE_OBJECTIVE && (
        <RemoveObjectiveForm
          goal={props.goal}
          objective={props.objective}
          onClose={props.onClose}
          onCloseAndAddObjective={props.onCloseAndAddObjective}
          onModalSubmission={props.onModalSubmission}
          patientDetails={props.patientDetails}
        />
      )}
      {props.modalMode === MODAL_MODES.CLOSE_AND_ADD_OBJECTIVE && (
        <AddObjectiveForm
          goal={props.goal}
          objective={props.objective}
          objectiveCloseMode={props.objectiveCloseMode}
          onClose={props.onClose}
          onCompleteObjectiveClick={props.onCompleteObjectiveClick}
          onModalSubmission={props.onModalSubmission}
          onRemoveObjectiveClick={props.onRemoveObjectiveClick}
          patientDetails={props.patientDetails}
          providerObjectiveOptions={props.providerObjectiveOptions}
          providerObjectiveOptionsMap={props.providerObjectiveOptionsMap}
        />
      )}
    </Modal>
  );
}
